import {
  CommunicationSizeComponent,
  ComponentIds,
  TemplateDataComponent
} from '@inter-ikea-core/core';
import { CoreApi, ProductType } from '@inter-ikea-storageone/range';
import { store } from 'ducks';

// Error to be displayed when user tries to add regular interiors before having regular BROR sections
export const hideBrorAddingRegularInteriorToWallSystemFrameErrorMessage = (coreApi: CoreApi) => {
  const framesInScene = coreApi.entities.getByComponent(ComponentIds.FRAME_COMPONENT_ID);

  const wallSystemFrames = framesInScene.filter(
    f =>
      f.getComponent<TemplateDataComponent>(ComponentIds.TEMPLATE_DATA_COMPONENT_ID)?.templateId ===
      'wall-unit'
  )?.length;
  const regularFrames = framesInScene?.length - wallSystemFrames;
  const onlyWallSystemFrames = wallSystemFrames > 0 && regularFrames === 0;
  const isBrorWallMountSystem = store.getState().range.selectedRange === 'bror-wall-mounted';

  return !onlyWallSystemFrames || isBrorWallMountSystem;
};

// Error to be displayed when user tries to add interiors from BROR Wall System before having sections BROR Wall System
export const hideBrorAddingWallSystemInteriorToRegularFrameErrorMessage = (coreApi: CoreApi) => {
  const framesInScene = coreApi.entities.getByComponent(ComponentIds.FRAME_COMPONENT_ID);

  const wallSystemFrames = framesInScene.filter(
    f =>
      f.getComponent<TemplateDataComponent>(ComponentIds.TEMPLATE_DATA_COMPONENT_ID)?.templateId ===
      'wall-unit'
  )?.length;

  const regularFrames = framesInScene?.length - wallSystemFrames;
  const onlyRegularFrames = wallSystemFrames === 0 && regularFrames > 0;
  const isBrorWallMountSystem = store.getState().range.selectedRange === 'bror-wall-mounted';

  return !onlyRegularFrames || !isBrorWallMountSystem;
};

// Error to be displayed when user tries to add a cabinet to a section, and have either just a 55cm section, or mixed depths of sections in the scene
export const hideBrorNoMatchingFramesForCabinetErrorMessage = (coreApi: CoreApi) => {
  const framesInScene = coreApi.entities.getByProductTypes([ProductType.BROR_SECTION]);
  const framesSupportingCabinet = framesInScene.filter(frame => {
    const size = frame.getComponent<CommunicationSizeComponent>(
      ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID
    )?.size;
    return size?.depth === 400 && size?.width === 850;
  });

  return framesSupportingCabinet.length > 0 || framesInScene.length === 0;
};

// Error to be displayed when user tries to add a drawer to a section, and have either just a 85cm wide section, or mixed depths of sections in the scene and tries to drag a drawer to a 85cm wide section
export const hideBrorNoMatchingFramesForDrawersErrorMessage = (coreApi: CoreApi) => {
  const framesInScene = coreApi.entities.getByProductTypes([ProductType.BROR_SECTION]);
  const framesSupportingDrawer = framesInScene.filter(frame => {
    const size = frame.getComponent<CommunicationSizeComponent>(
      ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID
    )?.size;
    return size?.width === 850;
  });

  return framesSupportingDrawer.length > 0 || framesInScene.length === 0;
};
